<template>
  <div>
    <div class="tab" v-if="!currentTicketResult">
      <loader v-if="isLoadingQuestions.questions || isLoadingProgress"></loader>

      <template v-else>
        <div class="tab__header">
          <router-link to="/pdd/tickets" class="come-back">Назад к списку билетов</router-link>
          <div class="h2 tab__title">Билет {{ currentTicketId }}</div>
          <div class="timer">{{ timeFromSeconds }}</div>
        </div>

        <div class="tab__question">
          <div class="sly-wrap">
            <div ref="questions-slider" class="sly">
              <div class="slider-number">
                <div
                  v-for="(question, index) of questions"
                  :class="getQuestionClass(index)"
                  :key="index"
                  class="slider-number__item"
                  @click="goToQuestion(index)"
                >{{ index + 1 }}</div>
              </div>
            </div>

            <div class="sly-arrow"></div>
          </div>

          <div class="ticket-question__image"><img v-if="currentQuestion.image" :src="`${$APP_URL}/storage/${currentQuestion.image}`" class="mb-3 w-100"/></div>

          <div class="ticket-question">
            <div class="ticket-number">Вопрос {{ currentQuestionIndex + 1 }}</div>
            <div class="timer">{{ timeFromSeconds }}</div>
            <div class="h3" v-html="currentQuestion.text"></div>
          </div>

          <form>
            <div
              v-for="(answer, key, index) in getAnswersOfQuestion(currentQuestion)"
              :key="index"
              :class="getAnswerClass(key, currentQuestionIndex)"
              class="checkout-group"
            >
              <input @click="answerOnQuestion(key)" type="radio" name="checkout-radio" :id="index" class="checkout-group__input">
              <label :for="index" class="checkout-group__label">
                <span>{{ index + 1 }}</span>
                <div class="checkout-group__text">{{ answer }}</div>

                <div v-if="isShowComment(key)" class="answer-info">
                  <hr>
                  <div class="text"  v-html="currentQuestion.comment"></div>
                </div>
              </label>
            </div>

            <button ref="next-button" @click.prevent="goToNextQuestion" :disabled="!isQuestionAnswered" class="btn btn-green">Далее</button>
          </form>
        </div>
      </template>
    </div>

    <div v-if="currentTicketResult">
      <div class="tab">
        <div class="tab__header">
          <div class="tab__title h2">Билет {{ !currentTicketResult.passed ? 'Не' : '' }} сдан</div>
        </div>

        <div class="flex flex-justify-sb result">
          <div class="result-item"><span><span class="green">{{ currentTicketResult.rightCount }}</span>/{{ currentTicketResult.questionsCount }}</span> правильных ответов</div>
          <div class="result-item">Затраченное время: {{ elapsedTimeFormat }}</div>
          <div class="result-item">{{ currentTicketResult.errorsCount }} Ошибок в билете </div>
        </div>

        <div class="result-link">
          <button type="button" @click="reloadQuestions" class="btn btn-green">пройти еще раз</button>
          <share-results-form
            test-type="ticket"
            :test-data="currentTicketResult"
            :taked-time="elapsedTimeFormat"
            :pre-generated-url="preGeneratedUrl"
          />
          <router-link :to="{ path: '/pdd/tickets', query: { coll: currentTicketCollectionId }}">Перейти к списку билетов</router-link>
        </div>
      </div>

      <div v-if="currentTicketResult.wrongCount > 0" class="h3 title text-center">Ваши ошибки</div>

      <div class="wrong" v-for="question of answeredQuestions" v-if="question.answer !== question.question.correct_answer" :key="question.index">
        <div class="wrong-header">
          <div class="wrong-number">Вопрос {{ question.index }}</div>
          <div class="wrong-question" v-html="question.question.text"></div>
          <div class="wrong-btn js-wrong-btn" data-open="close">Показать</div>
        </div>

        <img v-if="question.question.image" :src="`${$APP_URL}/storage/${question.question.image}`" class="wrong-img"/>

        <div class="wrong-block">
          <div class="answer"
               v-for="(answer, key, index) in question.answers"
               :key="index"
               :class="{ 'answer-right': question.question.correct_answer === key, 'answer-wrong': key === question.answer }"
          >
            <div class="answer-header">
              <div class="answer-number">{{ index + 1 }}</div>
              <div class="answer-title">{{ answer }}</div>
            </div>

            <div class="answer-info" v-if="question.question.correct_answer === key">
              <hr>
              <div class="text" v-html="question.question.comment"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="time-lost" hide-footer no-close-on-backdrop hide-header-close>
      <div class="modal-header"></div>
      <div class="h3 modal-title">Время прохождения билета истекло!</div>
      <a @click="reloadQuestions" class="btn btn-green modal-btn">Пройти еще раз</a>
      <router-link :to="{ path: '/pdd/tickets', query: {coll: currentTicketCollectionId } }" class="modal-link">Перейти к списку билетов</router-link>
    </b-modal>

    <b-modal ref="unfinished-ticket" hide-footer no-close-on-backdrop hide-header-close hide-header>
      <div class="modal-header"></div>
      <div class="h3 modal-title">Хотите продолжить решение билета?</div>
      <a @click="continueTicket" class="btn btn-green modal-btn">Продолжить</a>
      <a @click="reloadQuestions" href="#" class="modal-link">Начать заново</a>
    </b-modal>
  </div>
</template>


<script>
  import 'sly-scrolling/dist/sly';
  import { mapActions } from 'vuex';
  import mainMixin from '../../mixins/tests/main';
  import ShareResultsForm from '@/components/pdd/ShareResultsForm.vue';
  import settings from '@/settings';

  export default {
    name: 'TicketQuestions',
    components: { ShareResultsForm },
    mixins: [mainMixin],
    data() {
      return {
        currentTicketId: parseInt(this.$route.params.id, 10),
        currentTicketCollectionId: parseInt(this.$route.query.coll, 10),
        currentQuestionIndex: null,
        currentTicketResult: null,
        answeredQuestions: [],
        answeredQuestionsForProgress: [],
        timer: null,
        lastResultUpdate: null,
        elapsedTime: 0,
        timerId: null,
        preGeneratedUrl: '',
        usedMegapolisProgress: false,
        megapolisProgressPending: false,
      };
    },
    computed: {
      questions() {
        return this.$store.getters.questions;
      },
      isLoadingProgress() {
        return this.$store.getters['progress/progressLoader'];
      },
      isLoadingQuestions() {
        return this.$store.getters.collectionsLoaders;
      },
      isQuestionAnswered() {
        return !!this.getAnswerOnCurrentQuestion();
      },
      timeFromSeconds() {
        return this.getHms(this.timer);
      },
      elapsedTimeFormat() {
        return this.getHms(this.elapsedTime);
      },
    },
    methods: {
      ...mapActions('progress', ['setProgress', 'getProgress', 'clearProgress']),
      ...mapActions('testResult', ['saveTestResult']),
      getTicketQuestions() {
        this.$store.dispatch('getTicketQuestions', {
          collectionId: this.currentTicketCollectionId,
          ticketId: this.currentTicketId,
        })
          .then(() => {
            const taskId = Number(settings.MEGAPOLIS_TASK_ID);
            const collId = Number(settings.MEGAPOLIS_COLLECTION_ID);

            if (settings.MEGAPOLIS_LESSON_ID && taskId === this.currentTicketId && collId === this.currentTicketCollectionId) {
              this.fillProgressFromMegapolis()
                .then((applied) => {
                  if (!applied) {
                    this.startOverForMegapolis();
                  }
                })
                .catch(() => {
                  this.startOverForMegapolis();
                });
            } else {
              this.checkUnfinishedTicket();
            }
          });
      },
      startOverForMegapolis() {
        const { ticketResults } = this.$appSettings;
        for (let i = ticketResults.length - 1; i >= 0; i--) {
          const t = ticketResults[i];
          if (t.ticketId === this.currentTicketId && t.collectionId === this.currentTicketCollectionId) {
            ticketResults.splice(i, 1);
          }
        }
        if (typeof this.updateAppSettings === 'function') {
          this.updateAppSettings();
        }

        if (this.$refs['unfinished-ticket']) {
          this.$refs['unfinished-ticket'].hide();
        }

        this.answeredQuestions = [];
        this.answeredQuestionsForProgress = [];
        this.preGeneratedUrl = '';
        this.usedMegapolisProgress = false;
        this.megapolisProgressPending = false;

        this.currentQuestionIndex = 0;
        this.elapsedTime = 0;
        this.timer = this.questions && this.questions.length ? this.questions.length * 60 : null;

        this.initSly();
        if (!this.timerId && this.timer && this.timer > 0) {
          this.startTimer();
        }
      },
      async fillProgressFromMegapolis() {
        try {
          const resp = await this.getProgress({
            test_url: `${settings.APP_URL}${this.$route.path}?coll=${this.$route.query.coll}`,
            lesson_id: settings.MEGAPOLIS_LESSON_ID,
          });

          let progressData = null;

          if (resp && resp.result) {
            progressData = resp;
          } else if (this.progress && this.progress.result) {
            progressData = this.progress;
          }

          if (!progressData || !progressData.result || !Array.isArray(progressData.result.results) || !progressData.result.results.length) {
            return false;
          }

          this.answeredQuestions = [];
          this.answeredQuestionsForProgress = [];

          for (const item of progressData.result.results) {
            const qNumber = Number(item.question_number);

            if (!Number.isNaN(qNumber) && qNumber >= 1) {
              const questionObj = this.questions[qNumber - 1];

              if (questionObj) {
                const userAnswer = item.is_correct ? questionObj.correct_answer : null;

                this.answeredQuestions.push({
                  answer: userAnswer,
                  index: qNumber,
                  question: questionObj,
                  answers: this.getAnswersOfQuestion(questionObj),
                });

                this.answeredQuestionsForProgress.push({
                  question_number: qNumber,
                  is_correct: !!item.is_correct,
                });
              }
            }
          }

          const firstUnanswered = this.getFirstUnansweredQuestionIndex();
          this.currentQuestionIndex = (firstUnanswered !== null && firstUnanswered !== undefined) ? firstUnanswered : 0;

          this.initSly();

          if (!this.timer) {
            this.timer = this.questions.length * 60;
          }

          this.usedMegapolisProgress = true;
          this.megapolisProgressPending = true;

          if (this.answeredQuestions.length === this.questions.length) {
            await this.clearProgress();

            this.startOverForMegapolis();

            return true;
          }

          this.$nextTick(() => {
            if (this.$refs['unfinished-ticket']) {
              this.$refs['unfinished-ticket'].show();
            }
          });

          return true;
        } catch (e) {
          return false;
        }
      },
      startTimer() {
        this.timerId = setInterval(() => {
          this.timer--;
          this.elapsedTime++;

          if ((this.lastResultUpdate - this.timer) >= 10) {
            this.updateTicketResults();
          }

          if (this.timer <= 0) {
            this.stopTimer();
            this.updateTicketResults();

            this.$refs['time-lost'].show();
          }
        }, 1000);
      },
      stopTimer() {
        clearInterval(this.timerId);
      },
      initQuestions() {
        const canContinueTicket = this.timer;

        this.currentQuestionIndex = this.currentQuestionIndex || 0;
        this.timer = this.timer || this.questions.length * 60;

        this.initSly();

        if (!canContinueTicket) {
          this.startTimer();
        }
      },
      getQuestionClass(index) {
        const isQuestionAnswered = !!this.getAnsweredQuestionByIndex(index);
        const isActiveQuestion = index === this.currentQuestionIndex;
        const currentAnsweredQuestion = this.getAnsweredQuestionByIndex(index);

        const isWrongAnswered = isQuestionAnswered
          ? currentAnsweredQuestion.answer !== currentAnsweredQuestion.question.correct_answer
          : false;

        const isRightAnswered = isQuestionAnswered
          ? currentAnsweredQuestion.answer === currentAnsweredQuestion.question.correct_answer
          : false;

        return {
          'active-item': isActiveQuestion,
          fail: isWrongAnswered,
          success: isRightAnswered,
        };
      },
      getAnswerClass(key) {
        const isUserAnswer = this.isQuestionAnswered && key === this.getAnswerOnCurrentQuestion().answer;
        const isCorrectAnswer = this.isQuestionAnswered && key === this.getAnswerOnCurrentQuestion().question.correct_answer;

        return {
          'answer-wrong': isUserAnswer && !isCorrectAnswer,
          'answer-right': isCorrectAnswer,
        };
      },
      isShowComment(key) {
        return this.isQuestionAnswered
          && key === this.getAnswerOnCurrentQuestion().question.correct_answer
          && this.getAnswerOnCurrentQuestion().answer !== this.getAnswerOnCurrentQuestion().question.correct_answer;
      },
      getAnswersOfQuestion(question) {
        const answers = {};

        for (const prop in question) {
          if (/^answer\d+/.test(prop) && question[prop]) {
            answers[prop] = question[prop];
          }
        }

        return answers;
      },
      fillAnsweredQuestionsForProgress() {
        if (!this.answeredQuestions.length) {
          this.answeredQuestionsForProgress = [];
          return;
        }

        this.answeredQuestionsForProgress = this.answeredQuestions.map(a => ({
          question_number: a.index,
          is_correct: a.answer === a.question.correct_answer,
        }));
      },
      async answerOnQuestion(answer) {
        const isCorrectAnswer = this.currentQuestion.correct_answer === answer;

        if (this.isQuestionAnswered) {
          return;
        }

        this.answeredQuestions.push({
          answer,
          index: this.currentQuestionIndex + 1,
          question: this.currentQuestion,
          answers: this.getAnswersOfQuestion(this.questions[this.currentQuestionIndex]),
        });

        this.answeredQuestionsForProgress.push({
          question_number: this.currentQuestionIndex + 1,
          is_correct: isCorrectAnswer,
        });

        const isLastAnswer = this.answeredQuestions.length === this.questions.length;

        const taskId = Number(settings.MEGAPOLIS_TASK_ID);
        const collId = Number(settings.MEGAPOLIS_COLLECTION_ID);

        if (settings.MEGAPOLIS_BEARER_TOKEN && settings.MEGAPOLIS_LESSON_ID && taskId === this.currentTicketId && collId === this.currentTicketCollectionId) {
          this.usedMegapolisProgress = false;
          const progressData = {
            test_url: `${settings.APP_URL}${this.$route.path}?coll=${this.$route.query.coll}`,
            lesson_id: settings.MEGAPOLIS_LESSON_ID,
            result: {
              results: this.answeredQuestionsForProgress,
            },
          };

          this.setProgress(progressData);
        }

        if (isLastAnswer && settings.MEGAPOLIS_BEARER_TOKEN && settings.MEGAPOLIS_LESSON_ID && taskId === this.currentTicketId && collId === this.currentTicketCollectionId) {
          const saveData = {
            type: 'ticket',
            category_id: this.currentTicketCollectionId,
            ticket_id: this.currentTicketId,
            payload: {
              answered_questions: this.answeredQuestions,
            },
            results: {
              taked_time: this.elapsedTimeFormat,
              time: this.timer,
              questions_count: this.questions.length,
              correct_answers_count: this.answeredQuestions.filter(question => question.answer === question.question.correct_answer).length,
              wrong_answers_count: this.answeredQuestions.filter(question => question.answer !== question.question.correct_answer).length,
              passed: this.answeredQuestions.length === this.questions.length && this.answeredQuestions.filter(question => question.answer !== question.question.correct_answer).length <= 2,
              done: this.isTestDone,
            },
          };

          const resp = await this.saveTestResult(saveData);
          const resultsUrl = resp && resp.uuid ? `${settings.APP_URL}/pdd/results/${resp.uuid}` : '';

          if (resultsUrl) {
            this.preGeneratedUrl = resultsUrl;

            const progressWithUrl = {
              title: `Билет №${this.currentTicketId}`,
              test_url: `${settings.APP_URL}${this.$route.path}?coll=${this.$route.query.coll}`,
              lesson_id: settings.MEGAPOLIS_LESSON_ID,
              result: {
                results: this.answeredQuestionsForProgress,
                results_url: resultsUrl,
                duration_seconds: this.elapsedTime,
              },
            };

            this.setProgress(progressWithUrl);
          }
        }

        this.updateTicketResults();

        if (this.isTestDone) {
          this.stopTimer();
          this.showTicketResult();
        }

        if (isCorrectAnswer) {
          this.goToNextQuestion();
        }
      },
      showTicketResult() {
        clearInterval(this.timerId);

        this.initResultDropdowns();
      },
      updateTicketResults() {
        const { ticketResults } = this.$appSettings;
        const questionsCount = this.questions.length;
        const rightsAnswers = this.answeredQuestions
          .filter(question => question.answer === question.question.correct_answer)
          .length;
        const wrongAnswers = this.answeredQuestions
          .filter(question => question.answer !== question.question.correct_answer)
          .length;

        const currentTicketResult = {
          collectionId: this.currentTicketCollectionId,
          ticketId: this.currentTicketId,
          questionsCount,
          rightCount: rightsAnswers,
          wrongCount: wrongAnswers,
          errorsCount: questionsCount - rightsAnswers,
          time: this.timer,
          passed: this.answeredQuestions.length === this.questions.length && wrongAnswers <= 2,
          answeredQuestions: this.answeredQuestions,
          done: this.isTestDone,
        };

        for (const [index, ticket] of ticketResults.entries()) {
          const hasTicketExist = ticket.ticketId === this.currentTicketId
            && ticket.collectionId === this.currentTicketCollectionId;

          if (hasTicketExist) {
            ticketResults.splice(index, 1);
          }
        }

        ticketResults.push(currentTicketResult);
        this.updateAppSettings();
        this.lastResultUpdate = currentTicketResult.time;

        if (this.isTestDone) {
          this.answeredQuestions = this.answeredQuestions.sort((a, b) => a.index - b.index);
          this.currentTicketResult = currentTicketResult;
        }
      },
      goToNextQuestion() {
        this.goToQuestion(this.getFirstUnansweredQuestionIndex(this.currentQuestionIndex));
      },
      async reloadQuestions() {
        const { ticketResults } = this.$appSettings;

        for (const [index, ticket] of ticketResults.entries()) {
          const hasTicketExist = ticket.ticketId === this.currentTicketId
            && ticket.collectionId === this.currentTicketCollectionId;

          if (hasTicketExist) {
            ticketResults.splice(index, 1);
          }
        }

        if (this.$refs['unfinished-ticket']) {
          this.$refs['unfinished-ticket'].hide();
        }

        const taskId = Number(settings.MEGAPOLIS_TASK_ID);
        const collId = Number(settings.MEGAPOLIS_COLLECTION_ID);
        const isMegapolisUser = settings.MEGAPOLIS_LESSON_ID
          && taskId === this.currentTicketId
          && collId === this.currentTicketCollectionId;

        if (isMegapolisUser) {
          await this.clearProgress();

          if (this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
          }

          this.currentTicketResult = null;

          this.startOverForMegapolis();

          return;
        }

        const nextR = this.$route.query.r ? parseInt(this.$route.query.r, 10) + 1 : 1;

        const query = {
          coll: this.currentTicketCollectionId,
          r: nextR,
        };

        if (this.$route.query.lesson_id) {
          query.lesson_id = this.$route.query.lesson_id;
        }
        if (this.$route.query.megapolis_token) {
          query.megapolis_token = this.$route.query.megapolis_token;
        }

        this.$router.push({
          path: `/pdd/tickets/${this.currentTicketId}`,
          query,
        });
      },
      checkUnfinishedTicket() {
        const { ticketResults } = this.$appSettings;

        for (const ticket of ticketResults) {
          const hasTicketExist = ticket.ticketId === this.currentTicketId
            && ticket.collectionId === this.currentTicketCollectionId;

          if (hasTicketExist) {
            if (!ticket.done) {
              if (this.usedMegapolisProgress) {
                return;
              }

              this.answeredQuestions = ticket.answeredQuestions;
              this.fillAnsweredQuestionsForProgress();
              this.currentQuestionIndex = this.getFirstUnansweredQuestionIndex();
              this.timer = ticket.time;

              this.initQuestions();

              this.$refs['unfinished-ticket'].show();
              return;
            }
          }
        }

        this.initQuestions();
      },
      continueTicket() {
        if (this.$refs['unfinished-ticket']) {
          this.$refs['unfinished-ticket'].hide();
        }

        this.megapolisProgressPending = false;

        if (!this.timer) {
          this.timer = this.questions.length * 60;
        }

        if (!this.timerId && this.timer > 0) {
          this.startTimer();
        }
      },
      getHms(time) {
        const date = new Date(0);
        date.setSeconds(time);

        let timeString = null;

        if (date.toISOString().substring(11, 13) === '00') {
          timeString = date.toISOString().substring(14, 19);
        } else {
          timeString = date.toISOString().substring(11, 19);
        }

        return timeString;
      },
    },
    created() {
      this.getTicketQuestions();
    },
    beforeDestroy() {
      this.stopTimer();
    },
    destroyed() {
      this.clearProgress();
    },
  };
</script>
